import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/alzguard/alzguard_logo.png'
import _imports_1 from '../../assets/alzguard/alzguard_1.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#0a47ff"} }, "뇌건강 테스트", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("를 돕는 게임 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 다중 생체신호를 활용한 비대면 초기 치매 선별 ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 디지털 바이오마커 개발 및 사업화 ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" (2021년 과학기술부 과제 선정) ")

import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, sm, smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_img, {
      src: _imports_0,
      class: _normalizeClass(["logo ml-4", { xs: _unref(xs), ' mb-6 ': _unref(smAndUp) }])
    }, null, 8, ["class"]),
    _createVNode(_component_v_card_title, {
      class: _normalizeClass(["font-weight-medium", { 'text-h6': _unref(xs) }]),
      style: {"font-size":"2.25rem"}
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_v_row, {
      justify: "space-between",
      class: "py-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, {
              class: _normalizeClass(["font-weight-medium", { 'text-subtitle-1': _unref(xs) }]),
              style: {"line-height":"1.5","color":"#072347","font-size":"1.25rem","word-break":"keep-all"}
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { style: {"max-width":"650px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_1,
              class: _normalizeClass(["example", { xs: _unref(xs), sm: _unref(sm) }])
            }, null, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})